import { SocialMediaType } from 'api/graphql-global-types';

export const LINKABLE_SOCIALS_OPTIONS = [
  {
    label: 'Instagram',
    value: SocialMediaType.Instagram,
  },
  {
    label: 'Facebook',
    value: SocialMediaType.Facebook,
  },
  {
    label: 'Tiktok',
    value: SocialMediaType.Tiktok,
  },
];

export const SOCIALS_OPTIONS = [
  {
    label: 'X',
    value: SocialMediaType.Twitter,
  },
  {
    label: 'YouTube',
    value: SocialMediaType.Youtube,
  },
];
